import { APIS, URLS } from '@/shared/config/urls';
import { request } from '@/shared/utils/request';
import type {
  AdminAffiliateDetail,
  AdminAffiliatePage,
  AdminAffiliateParams,
  AdminAffiliateSummary,
  Withdrawal,
  WithdrawalList,
} from '../types/affiliate.types';

export const fetchAdminAffiliateSummary = async (): Promise<AdminAffiliateSummary> => {
  return await request.get(`${URLS.BACK_DSH}${APIS.adminAffiliateSummary}`);
};

export const fetchAdminAffiliates = async (
  params: AdminAffiliateParams
): Promise<AdminAffiliatePage> => {
  const query = new URLSearchParams();
  if (params.page) query.set('page', String(params.page));
  if (params.size) query.set('size', String(params.size));
  if (params.status) query.set('status', params.status);
  if (params.q) query.set('q', params.q);
  return await request.get(`${URLS.BACK_DSH}${APIS.adminAffiliates(query.toString())}`);
};

export const fetchAdminAffiliate = async (affiliateId: string): Promise<AdminAffiliateDetail> => {
  return await request.get(`${URLS.BACK_DSH}${APIS.adminAffiliate(affiliateId)}`);
};

/** Riwayat, newest first. */
export const fetchAdminWithdrawals = async (affiliateId: string): Promise<WithdrawalList> => {
  return await request.get(`${URLS.BACK_DSH}${APIS.adminAffiliateWithdrawals(affiliateId)}`);
};

/** Sudah Transfer: the due `amount` as Riwayat showed it (409 when the balance changed) and the proof
 *  photo (JPG / PNG, 5 MB). */
export const recordAdminPayout = async (
  affiliateId: string,
  amount: string,
  proof: File
): Promise<Withdrawal> => {
  const form = new FormData();
  form.append('amount', amount);
  form.append('proof', proof);
  return await request.post(`${URLS.BACK_DSH}${APIS.adminAffiliateWithdrawals(affiliateId)}`, form);
};
